import getBase64FromUrl from './base64Utils';

/**
 * Función para forzar la descarga de un
 * archivo en base64.
 *
 * @param {object} param
 * @param {string} param.linkSource
 * @param {string} param.fileName
 * @returns
 */
const downloadBase64File = ({ linkSource, fileName }) => {
  // Genera un elemento a y ejecuta su evento para forzar la descarga.
  const downloadLink = document.createElement('a');
  downloadLink.href = linkSource;
  downloadLink.download = fileName;
  downloadLink.click();
};

/**
 * Función para forzar la descarga de un
 * pdf archivo en base64.
 *
 * @param {object} param
 * @param {string} param.base64String
 * @param {string} [param.fileName='archivo.pdf']
 * @returns
 */
const downloadPdfBase64File = ({ base64String, fileName = 'archivo.pdf' }) => {
  // Agrega el content-type
  const linkSource = `data:application/pdf;base64, ${base64String}`;
  downloadBase64File({ linkSource, fileName });
};

/**
 * Función para forzar la descarga de un
 * png archivo en base64.
 *
 * @param {object} param
 * @param {string} param.base64String
 * @param {string} [param.fileName='archivo.png']
 * @returns
 */
const downloadPngBase64File = ({ base64String, fileName = 'archivo.png' }) => {
  // Agrega el content-type
  const linkSource = `data:application/png;base64, ${base64String}`;
  downloadBase64File({ linkSource, fileName });
};

/**
 * Función para forzar la descarga de un
 * mp3 archivo en base64.
 *
 * @param {object} param
 * @param {string} param.base64String
 * @param {string} [param.fileName='archivo.mp3']
 * @returns
 */
const downloadMp3Base64File = ({ base64String, fileName = 'archivo.mp3' }) => {
  // Agrega el content-type
  const linkSource = `data:application/mp3;base64, ${base64String}`;
  downloadBase64File({ linkSource, fileName });
};

/**
 * Función para forzar la descarga de un
 * jpg archivo en base64.
 *
 * @param {object} param
 * @param {string} param.base64String
 * @param {string} [param.fileName='archivo.mp3']
 * @returns
 */
const downloadJpgBase64File = ({ base64String, fileName = 'archivo.jpg' }) => {
  // Agrega el content-type
  const linkSource = `data:application/jpg;base64, ${base64String}`;
  downloadBase64File({ linkSource, fileName });
};

const downloadPdf = async ({ blob, fileName }) => {
  const urlDownLoad = URL.createObjectURL(blob);
  const doc = await getBase64FromUrl(urlDownLoad);
  downloadPdfBase64File({ base64String: doc, fileName });
};

export { downloadPdf, downloadPdfBase64File, downloadPngBase64File, downloadMp3Base64File, downloadJpgBase64File };
